import { Avatar, ListItem, ListItemIcon, ListItemText } from "@/components/ui";
import { IUser } from "@/shared/model/user.model";
import axios from "axios";
import { useEffect, useState } from "react";
import { cn } from "@/shared/util/cn";

interface TeacherRowProps {
  teacher: IUser;
  viewTeacher: (teacher: IUser) => void;
}

const TeacherRow = (props: TeacherRowProps) => {
  const [countInsegnamenti, setCountInsegnamenti] = useState<number>(0);
  const [countMateriale, setCountMateriale] = useState<number>(0);

  const { teacher, viewTeacher: handleViewTeacher } = props;

  const getCountInsegnamenti = async () => {
    const response = await axios.get<{ count: number }>(
      `/teachers/${teacher.id}/courses/count`
    );
    setCountInsegnamenti(response.data.count);
  };

  const getCountMateriale = async () => {
    const response = await axios.get<{ count: number }>(
      `/teachers/${teacher.id}/course-materials/count`
    );
    setCountMateriale(response.data.count);
  };

  useEffect(() => {
    if (teacher?.id) {
      getCountInsegnamenti();
      getCountMateriale();
    }
  }, [teacher?.id]);

  return (
    <ListItem
      className={cn(
        "flex cursor-pointer items-center gap-3 py-3 transition-colors hover:bg-primary/5"
      )}
      onClick={() => handleViewTeacher(teacher)}
    >
      <ListItemIcon>
        <Avatar
          alt={teacher.firstName + " " + teacher.lastName}
          fallback={
            (teacher.firstName?.[0] ?? "") + (teacher.lastName?.[0] ?? "U")
          }
          className="bg-primary/10 text-primary"
        />
      </ListItemIcon>
      <ListItemText
        primary={teacher.firstName + " " + teacher.lastName}
        secondary={`Insegnamenti: ${countInsegnamenti}, Materiale: ${countMateriale}`}
      />
    </ListItem>
  );
};

export default TeacherRow;
